import { orchestrator } from 'satcheljs';
import { Log } from '../../../logging/src';
import { onDoNotRenderDefaultPageChanged } from '../../pages/ad-management/@data/actions';
import { RouteName } from '../../pages/report/@data/store/store';
import { NewReportRoute, RoutePrefix } from '../../Routes';
import { onAuthLogout, redirectToReportingLandingPage } from '../actions';
import { getAppStore } from '../store/store';
import { isTythonSelfServeUser } from '../utils';

orchestrator(redirectToReportingLandingPage, async () => {
  const { publisher, userContext, defaultPublisher } = getAppStore();

  Log.write('Redirecting to reporting landing page...');

  if (userContext && publisher && publisher.id && publisher.id === defaultPublisher && !isTythonSelfServeUser()) {
    console.log('Redirecting to reporting landing page for non-Tython MSA user...');
    onDoNotRenderDefaultPageChanged(true);
    try {
      window.location.replace(`${window.location.origin}/${RoutePrefix.report}${NewReportRoute}/${publisher.id}/${RouteName.landing}`);
    } catch (e) {
      Log.write(`Recognized non-Tython MSA user, but failed to redirect to reporting dashboard.`);
      onAuthLogout();
    }
  }
});
